/* eslint-disable no-console */
import {Flex} from 'antd';
import React, {Fragment} from 'react';

import BoxContent from '../../../components/BoxContent/BoxContent';
import MainTableTitle from '../../../components/Table/Utils/MainTableTitle';
import {formatIndian} from '../../../utils/formatIndian';
import {
  filterMainAndSubData,
  roundToDecimal
} from '../constants/commonFunctions';
import FlexLegend from '../generalized/utils/FlexLegend';
import LineLegend from '../generalized/utils/LineLegend';
import {chartType, IChartLabelType} from '../interface/IChart';

import ChartSwitch from './ChartSwitch';

const LabelChart: React.FC<{
  data: any[];
  keyArray: string[];
  chartType?: chartType;
  dataInMainData?: boolean;
  noBackground?: boolean;
  showTitle?: boolean;
  tooltip?: string;
  labelType?: IChartLabelType;
  isValue?: boolean;
  customLabel?: string;
  showTotal?: boolean;
  customTotalTitle?: string;
  isCost?: boolean;
}> = ({
  data,
  keyArray,
  chartType = 'donut',
  noBackground = false,
  showTitle = true,
  dataInMainData = false,
  tooltip = '',
  labelType = 'line',
  isValue = true,
  customLabel = '',
  showTotal = false,
  customTotalTitle = undefined,
  isCost = false
}) => {
  const {mainData, subData} = filterMainAndSubData(data, 'dataId', keyArray);
  const mainTitle = mainData?.label?.split(' ') ?? [''];
  const lastWord = mainTitle[mainTitle?.length - 1];

  return (
    <BoxContent noBackground={noBackground}>
      <Flex className="ghgEmissionByScope" style={{gap: '1rem'}}>
        {showTitle && (
          <Flex className="titleFlex">
            <MainTableTitle
              title={mainData?.label}
              showDivider={false}
              tooltip={tooltip}
            />
          </Flex>
        )}
        {showTotal && (
          <Flex className="titleData">
            <div className="titleDataText">
              {customTotalTitle ?? `TOTAL ${lastWord}`}
            </div>
            <div className="titleDataValue">
              {isCost && <span>{`${mainData?.unit} `}</span>}

              {`${
                typeof mainData?.value === 'string'
                  ? mainData?.value
                  : formatIndian(roundToDecimal(mainData?.value ?? 0))
              } `}
              {!isCost && <span>{mainData?.unit ?? ''}</span>}
            </div>
          </Flex>
        )}
        <ChartSwitch
          data={dataInMainData ? {subData: subData ?? []} : {mainData, subData}}
          chartType={chartType}
          customLabel={customLabel}
        />
        <Flex vertical={true}>
          {subData?.map((item: any, index: number) => {
            return (
              <Fragment key={index}>
                {labelType === 'line' ? (
                  <LineLegend
                    index={index}
                    item={item}
                    length={subData?.length}
                    isCost={isCost}
                  />
                ) : (
                  <FlexLegend index={index} item={item} isValue={isValue} />
                )}
              </Fragment>
            );
          })}
          <></>
        </Flex>
      </Flex>
    </BoxContent>
  );
};

export default LabelChart;
